<h1 mat-dialog-title>
  {{ 'ASSOCIATIONS.REMOVE_DIALOG.TITLE' | translate }}
</h1>
<mat-dialog-content>
  <p>
    {{ 'ASSOCIATIONS.REMOVE_DIALOG.MESSAGE' | translate : { fromName: data.fromName, removeName: data.removeName } }}
  </p>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-stroked-button (click)="cancel()">
    {{ 'ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="warn" (click)="remove()">
    {{ 'ASSOCIATIONS.REMOVE_DIALOG.CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
